import { render } from "./NotSubmittedCard.vue?vue&type=template&id=7815390e&scoped=true"
import script from "./NotSubmittedCard.vue?vue&type=script&lang=js"
export * from "./NotSubmittedCard.vue?vue&type=script&lang=js"

import "./NotSubmittedCard.vue?vue&type=style&index=0&id=7815390e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7815390e"]])

export default __exports__